import { Dict } from "@lana-commerce/core/commonTypes";

import { CategoryBrief } from "../data/def";

export function getCategoryChain(briefs: Dict<CategoryBrief>, categoryID: string): CategoryBrief[] {
  const c = briefs[categoryID];
  if (!c) return [];
  return [...getCategoryChain(briefs, c.parentID), c];
}
